import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ProjectTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Projects",
      path: "/admin/projects"
    },
    {
      label: "Team",
      path: "/admin/project-membership"
    },
    {
      label: "Requirements",
      path: "/admin/project-requirement"
    },
    {
      label: "Shortlisted Candidates",
      path: "/admin/project-candidates"
    },
    {
      label: "Deployments",
      path: "/admin/deployment"
    },
   
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default ProjectTabs;